<template>
  <v-container class="mapping">
    <v-row>
      <v-col class="pt-0 pb-0" md="8">
        <v-row class="map-header">
          <v-col class="mr-auto" cols="auto">
            <h3>{{ $t('serviceBase.currentLocation', { location: '台北' })}}</h3>
          </v-col>
          <v-col cols="auto">
            <div class="icon-button" @click="showPolygon" :class="{ 'is-active': !showingPolygon }">
              <v-icon>mdi-map-marker</v-icon>
            </div>
            <div class="icon-button" @click="finishShowPolygon" :class="{ 'is-active': showingPolygon }">
              <v-icon>mdi-map-outline</v-icon>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="4"></v-col>
    </v-row>
    <v-row>
      <v-col md="8">
        <v-responsive :aspect-ratio="16/10">
          <google-map :zoom="range.zoom" :paths="insertPaths" :stations="stations" :riders="riders" :center="range.position" :options="options" @selectRider="setCurrentRider" @selectStation="setCurrentStation"></google-map>
        </v-responsive>
      </v-col>
      <v-col md="4">
        <site-status v-if="currentStation" :data="currentStation"></site-status>
        <rider-status class="mt-5" v-if="currentRider" :data="currentRider"></rider-status>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InsertPolygon from '@/mixins/InsertPolygon'
import GoogleMap from '@/components/GoogleMap'
import { FAKE_SITE_INFO } from '@/libs/fakeData'
import SiteStatus from '@/components/SiteStatus'
import RiderStatus from '@/components/RiderStatus'

export default {
  mixins: [InsertPolygon],
  components: { SiteStatus, RiderStatus, GoogleMap },
  data () {
    return {
      siteInfo: FAKE_SITE_INFO
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      currentStation: 'station/currentStation',
      riders: 'rider/list',
      currentRider: 'rider/currentRider',
      range: 'range/data'
    }),
    options () {
      return { showSiteStatusColor: this.showingPolygon }
    }
  },
  methods: {
    ...mapActions({
      selectRider: 'rider/select',
      selectStation: 'station/select'
    }),
    setCurrentRider ({ id }) {
      this.selectRider(id)
    },
    setCurrentStation ({ id }) {
      this.selectStation(id)
    }
  }
}
</script>
